import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["report"];
import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
// @ts-expect-error Untyped Dependency
import ReportWithResolve from './ReportWithResolve';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportWithRefresh = _ref => {
  let {
      report
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const reportRef = useRef(report);
  const [currentReport, setCurrentReport] = useState(report);
  useEffect(() => {
    // In case the report is changed via parent component, reset the report
    const prevReport = reportRef.current;
    reportRef.current = report;
    if (!prevReport.equals(report)) {
      setCurrentReport(report);
    }
  }, [report]);
  const refreshReportData = useCallback(({
    report: updatedReport
  }) => {
    setCurrentReport(updatedReport);
  }, []);
  return /*#__PURE__*/_jsx(ReportWithResolve, Object.assign({
    report: currentReport,
    refreshReportData: refreshReportData
  }, rest));
};
ReportWithRefresh.propTypes = {
  report: PropTypes.object
};
export default ReportWithRefresh;